module.exports = __webpack_public_path__ + "static/helpview-small-1da88c41cb8b7eb8e0521fbf4046486c.jpg";